function urlSafeBase64Encode(input: string): string {
  const base64 = btoa(input)
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function urlSafeBase64Decode(input: string): string {
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/')
  const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
  return atob(paddedBase64)
}

export async function compressAndBase64Encode(
  input: string,
  format: CompressionFormat = 'gzip'
): Promise<string> {
  const compressedStream = new Blob([input]).stream().pipeThrough(new CompressionStream(format))

  const compressedArrayBuffer = await new Response(compressedStream).arrayBuffer()
  const compressedBytes = new Uint8Array(compressedArrayBuffer)

  let binary = ''
  for (const byte of compressedBytes) {
    binary += String.fromCharCode(byte)
  }

  return urlSafeBase64Encode(binary)
}

export async function base64DecodeAndDecompress(
  input: string,
  format: CompressionFormat = 'gzip'
): Promise<string> {
  const binary = urlSafeBase64Decode(input)
  const compressedBytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    compressedBytes[i] = binary.charCodeAt(i)
  }

  const compressedStream = new Blob([compressedBytes]).stream()
  const decompressedStream = compressedStream.pipeThrough(new DecompressionStream(format))
  const decompressedArrayBuffer = await new Response(decompressedStream).arrayBuffer()
  const decoder = new TextDecoder()
  return decoder.decode(decompressedArrayBuffer)
}
